<div class="main-wrapper">
  <div class="header" *ngIf="!isInIframe">
    <div class="container">
      <div class="logo">
        
        <ng-container *ngIf="supplierLogoUrl; else fallbackName">
          <img [src]="supplierLogoUrl" alt="Company Logo">
        </ng-container>
        <ng-template #fallbackName>
          <span *ngIf="supplierCompanyName">{{ supplierCompanyName }}</span>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoadingSupplierDetails">
    <div class="spinner"></div>
    <!-- <div class="loading-text">Validating company details...</div> -->
  </div>

  <div class="container" [class.blur-content]="isLoadingSupplierDetails">

<div class="rfq-steps-nav">
  <div
    class="step"
    [class.completed]="currentStep > 1"
    [class.active]="currentStep === 1"
    (click)="goToStep(1)"
    [style.cursor]="isSubmitted ? 'not-allowed' : 'pointer'"
  >
    <span class="circle">1</span>
    <span class="label">Add RFQ Details</span>
  </div>
  <div
    class="step"
    [class.completed]="currentStep > 2"
    [class.active]="currentStep === 2"
    (click)="goToStep(2)"
    [style.cursor]="(step1Completed && !isSubmitted) ? 'pointer' : 'not-allowed'"
  >
    <span class="circle">2</span>
    <span class="label">Add Parts to Your RFQ</span>
  </div>
  <div
    class="step"
    [class.completed]="currentStep > 3"
    [class.active]="currentStep === 3"
    (click)="goToStep(3)"
    [style.cursor]="(step3Enabled && !isSubmitted) ? 'pointer' : 'not-allowed'"
  >
    <span class="circle">3</span>
    <span class="label">Review RFQ Summary</span>
  </div>
  <div
    class="step"
    [class.completed]="currentStep > 4"
    [class.active]="currentStep === 4"
    (click)="goToStep(4)"
    [style.cursor]="isSubmitted ? 'not-allowed' : 'pointer'"
  >
    <span class="circle">
      <ng-container *ngIf="isSubmitted; else stepFourNumber">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="32" fill="#111" />
          <path d="M20 33.5L28.5 42L44 26.5" stroke="white" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </ng-container>
      <ng-template #stepFourNumber>4</ng-template>
    </span>
    <span class="label">Submit RFQ</span>
  </div>
</div>

<div *ngIf="currentStep === 1">
  <app-rfq-details (next)="nextStep($event)"
  [showSummary]="rfqData?.showSummary"
  [hasUploadedFiles]="rfqData?.hasUploadedFiles"
  [supplierCompanyName]="supplierCompanyName" ></app-rfq-details>
</div>
<div *ngIf="currentStep === 2">
  <app-add-parts 
    [partToEdit]="rfqData?.selectedPartForEdit"
    [showSummary]="rfqData?.showSummary"
    [hasUploadedFiles]="rfqData?.hasUploadedFiles"
    (parentEmitter)="addPartsDataReceiver($event)">
  </app-add-parts>
</div>
<div *ngIf="currentStep === 3">
  <app-review-summary 
    [showSummary]="rfqData?.showSummary"
    [hasUploadedFiles]="rfqData?.hasUploadedFiles"
    (emitDataToParent)="nextStep($event)"
    (goBack)="prevStep($event)"></app-review-summary>
</div>
<div *ngIf="currentStep === 4">
  <app-submit  (goBack)="prevStep($event)"></app-submit>
   
</div>
</div>
</div>